import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { url, url_ws } from "src/app/config/config";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class GenericService {
  public myurl = url_ws + "generic/";
  public informesUrl = url + "informes/";

  constructor(private http: HttpClient) {}

  getList(database) {
    return this.http.get(this.myurl + "list.php?database=" + database).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getCrossList(database, database2, campo1, campo2) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    let data = {
      database,
      database2,
      campo1,
      campo2,
    };

    let body = JSON.stringify(data);
    return this.http.post(this.myurl + "crossList.php", body).pipe(
      map((res) => {
        return res;
      })
    );
  }

  /**
   *
   * @param database Nombre de la tabla de la base de datos a ingresar
   * @param orderby Si deseamos tener un orden al obtener los datos
   * @param where Si queremos poner una condicion a la hora de obtener los datos
   * @returns Retorna una respueta de tipo objeto
   */
  getListSimple(database, orderby = "", where = "") {
    if (orderby == null) {
      orderby = "";
    }
    if (where == null) {
      where = "";
    }
    return this.http
      .get(
        this.myurl +
          "listSimple.php?database=" +
          database +
          "&where=" +
          where +
          "&orderby=" +
          orderby
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getId(id, database) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    // let body = JSON.stringify([{ "id": id }]);
    let body = JSON.stringify([{ id: id }]);
    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.myurl + "getId.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  create(data: any, database) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    let body = JSON.stringify(data);

    return this.http
      .post(this.myurl + "create.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
  /*  duplicateCuaderno(id: any) {
    let headers = new HttpHeaders();
    let body = JSON.stringify({id:id});
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.myurl + "duplicate.php", body, { headers: headers }).pipe(map(resp => {
      return resp;
    }))
  } */
  update(cuaderno: any, database) {
    let headers = new HttpHeaders();
    //let body = JSON.stringify(cuaderno);

    let body = JSON.stringify(cuaderno);
    headers.append("Content-Type", "application/json");
    return this.http
      .put(this.myurl + "update.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
  delete(id, database) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    console.log("myurl", this.myurl);

    const params = new HttpParams()
      .set("id", id.toString())
      .set("database", database);

    return this.http.delete(this.myurl + "delete.php", { params }).pipe(
      map((data) => {
        return data;
      })
    );
  }
  borrar(id, database) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    const params = new HttpParams()
      .set("id", id.toString())
      .set("database", database);

    return this.http.delete(this.myurl + "borrar.php", { params }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  informe(id, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{ id: id }]);

    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.informesUrl + "genericId.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
  /**
   *  Enviar el campo de base de datos
   *  el valor de ese campo
   * y la base de datos que necesitamos acceder
   *
   * @param {*} field
   * @param {*} value
   * @param {*} database
   * @returns
   * @memberof GenericService
   */
  getNameField(field, value, database) {
    let headers = new HttpHeaders();
    let body = JSON.stringify([{ field: field, value: value }]);

    headers.append("Content-Type", "application/json");
    return this.http
      .post(this.myurl + "getNameField.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  deleteImageFrutoHueso(id, database) {
    return this.getId(id, database)
      .toPromise()
      .then((resp: any) => {
        console.log("resp", resp);

        let nombre = resp[0].nombre;

        return this.http
          .get(url + "fileupload/fileDelteImageFrutos.php?nombre=" + nombre)
          .toPromise();
      });
  }

  clone(myid: string, database) {
    let headers = new HttpHeaders();
    let id = myid;
    let body = JSON.stringify(id);
    headers.append("Content-Type", "application/json");

    return this.http
      .post(this.myurl + "clone.php?database=" + database, body, {
        headers: headers,
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }
}
